import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setSectionFormType } from '../../../../Features/storefrontSlice';
import AboutOneLogo from '../../../../Assets/StorefrontIcons/AboutOneLogo.svg';

function AboutOne() {
    const dispatch = useDispatch();

    const viewType = useSelector((state) => state.storefront.viewType);

    function handleClick() {
        dispatch(setSectionFormType(`ABOUT_ONE${viewType === 'MOBILE' ? '' : '_DESKTOP'}`));
    }

    return (
        <button onClick={handleClick} className="p-[10px] border border-[#EAEAEA] flex flex-col items-center gap-2 rounded-2xl outline-none select-none">
            <div className="w-full h-[100px] flex gap-2 rounded-md bg-[#EAEAEA] p-2">
                <div className="h-full aspect-square">
                    <img className='size-full object-cover' src={AboutOneLogo} alt="" />
                </div>

                <div className="flex flex-col flex-grow text-[#000000]">
                    <h1 className='font-semibold text-[12px] leading-5 text-left'>About us</h1>

                    <p className='font-medium text-[8px] leading-[14px] text-left'>Unleash Your Inner Style Icon with Brand: The Ultimate Fashion Must-Have!</p>
                </div>
            </div>

            <p className='font-medium text-[12px] leading-5 text-[#121212]'>About 1</p>
        </button>
    );
}

export default AboutOne;
